export default "__VITE_ASSET__$84yyHpD__"